import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import networkReducer from './networkReducer';
import authReducer from './authReducer';
import loginReducer from './loginReducer';
import signupReducer from './signupReducer';
import autoSaveReducer from './autoSaveReducer';
import scribesReducer from './scribesReducer';
import uiReducers from './uiReducers';
import imagesReducer from './imagesReducers';
import paymentReducer from './paymentReducer';
import downloadReducer from './downloadReducer';
import checkoutReducer from './checkoutReducer';
import locationReducer from './locationReducer';
import templatesReducer from './templatesReducer';
import marketingReducer from './marketingReducer';
import playbackReducer from './playbackReducer';
import userSettingsReducer from './userSettingsReducer';
import croppingReducer from './croppingReducer';

const createRootReducer = history =>
  combineReducers({
    router: connectRouter(history),
    network: networkReducer,
    auth: authReducer,
    login: loginReducer,
    signup: signupReducer,
    autoSave: autoSaveReducer,
    scribes: scribesReducer,
    ui: uiReducers,
    images: imagesReducer,
    payment: paymentReducer,
    download: downloadReducer,
    checkout: checkoutReducer,
    location: locationReducer,
    templates: templatesReducer,
    marketing: marketingReducer,
    playback: playbackReducer,
    userSettings: userSettingsReducer,
    cropping: croppingReducer
  });

export default createRootReducer;
